<template>
  <div class="container-fluid">
    <template v-if="setting">
      <div class="d-flex align-items-center my-2">
        <back-button to="/settings/notifications"/>
        <h1 class="mr-auto my-0">
          Настройка уведомлений
          <span v-if="setting && setting.user">для пользователя: {{ setting.user | fullName }}</span>
        </h1>
        <btn-action @click="save" class="btn btn-primary">Сохранить изменения</btn-action>
      </div>

      <div class="row">
        <div class="col-md-8">
          <div class="card mb-4">
            <div class="card-header d-flex align-items-center">
              <h3 class="my-0 mr-auto"><span class="text-caps">Список автоматов</span></h3>
              <button type="button" class="btn btn-outline-primary btn-sm" @click="editMachines">Добавить автомат</button>
            </div>
            <table class="table table-sm m-0">
              <thead>
              <tr>
                <td class="font-weight-bold">№</td>
                <td class="font-weight-bold">Адрес</td>
                <td class="font-weight-bold">Техник</td>
                <td class="font-weight-bold">Оператор</td>
                <td class="font-weight-bold">Менеджер</td>
                <td class="font-weight-bold">Организация</td>
                <td class="font-weight-bold"></td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(machine, index) in setting.machines">
                <td>{{ machine.serial_number }}</td>
                <td>{{ machine.address }}</td>
                <td>{{ machine.technician | fullName }}</td>
                <td>{{ machine.operator | fullName }}</td>
                <td>{{ machine.manager | fullName }}</td>
                <td>{{ machine.region && machine.region.name }}</td>
                <td>
                  <button @click="deleteMachine(index)" class="btn btn-outline-danger btn-sm">
                    <font-awesome-icon icon="trash-alt" class="m-0"/>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card mb-4">
            <div class="card-header d-flex align-items-center">
              <h3 class="my-0 mr-auto"><span class="text-caps">Список событий</span></h3>
              <button type="button" class="btn btn-outline-primary btn-sm" @click="editEvent">Выбрать</button>
            </div>
            <table class="table table-sm m-0">
              <tr v-for="(event, index) in setting.event_codes">
                <td class="align-middle">{{ event.event_code | eventName }}</td>
                <td class="align-middle">
                  <font-awesome-icon icon="comment-alt" :class="event.send_sms? 'active_icon' : 'inactive_icon'"/>
                </td>
                <td class="align-middle">
                  <font-awesome-icon icon="at" :class="event.send_email? 'active_icon' : 'inactive_icon'"/>
                </td>
                <td class="align-middle">
                  <button @click="deleteEvent(index)" class="btn btn-outline-danger btn-sm">
                    <font-awesome-icon icon="trash-alt" class="m-0"/>
                  </button>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import api from '@/api'
  import EventModal from '../../../components/event-modal.vue'
  import MachinesModal from '../../../components/machines-modal.vue'
  import filters from '../../../filters'

  export default {
    metaInfo () {
      const userName = this.setting && this.setting.user ? filters.fullName(this.setting.user) : ''
      return {title: `Настройка уведомлений для пользователя: ${userName}`}
    },
    props: {
      id: {required: true},
    },
    methods: {
      save () {
        return api.put(`notification_settings/${this.id}`, {
          event_codes: this.setting.event_codes || [],
          machine_ids: this.setting.machines ? this.setting.machines.map((machine) => machine.id) : [],
        })
      },
      deleteEvent (index) {
        this.setting.event_codes.splice(index, 1)
      },
      deleteMachine (index) {
        this.setting.machines.splice(index, 1)
      },
      editEvent () {
        this.$root.showModal(EventModal, {
          value: this.setting.event_codes,
        }).then((data) => {
          if (data) this.setting.event_codes = data
        })
      },
      editMachines () {
        this.$root.showModal(MachinesModal, {
          checked: this.setting.machines.map((machine) => machine.id),
        }).then((value) => {
          if (value) {
            this.setting.machines = this.setting.machines.concat(value)
          }
        })
      },
    },
    asyncComputed: {
      setting () {
        return api.get(`notification_settings/${this.id}`).then(({data}) => data.data)
      },
    },
  }
</script>

<style lang="scss">
  .inactive_icon {
    color: #ced4da;
  }
  .active_icon {
    color: #00a0e3;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/notifications/_id.vue